import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import './Layout.css';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        console.log('Toggle Sidebar');
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="app-container">
            <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

            {/* Overlay für mobile Ansicht */}
            {isSidebarOpen && window.innerWidth <= 768 && (
                <div className="overlay" onClick={toggleSidebar} />
            )}

            <Sidebar isOpen={isSidebarOpen} />

            <main className="content-wrapper">
                {children}
            </main>
        </div>
    );
};

export default Layout;